import SideMenu, { SideMenuProps } from '@elem/compCommon/SideMenu';
import { createPortal } from 'react-dom';
import { useGlobal } from '@/utils/useGlobal';
import B from './components/UsPage/B';
import C from './components/UsPage/C';
import D from './components/UsPage/D';
import E from './components/UsPage/E';
import F from './components/UsPage/F';
import G from './components/UsPage/G';
import R from './components/UsPage/H';
import FooterTcA from './components/UsPage/FooterTcA';

export default function IndexDynamic() {
    const { useState, useLang, useEffect } = useGlobal();
    const [isClient, setIsClient] = useState(false);
    const { t } = useLang('costsaving-new');

    const obj: SideMenuProps = {
        items: [
            { text: t('secC_btn1'), link: '#cost-saving-C' },
            { text: t('secC_btn2'), link: '#cost-saving-E' },
            // { text: t('secC_btn3'), link: '#cost-saving-J' },
            // { text: t('secC_btn4'), link: '#cost-saving-L' },
        ],
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsClient(true);
        }
    }, []);

    return (
        <>
            <>
                <B />
                <C />
                <D />
                <E />
                <F />
                <G />
                <R />
                <FooterTcA />
            </>
            {isClient && createPortal(<SideMenu items={obj.items} />, document.querySelector('#Widgets-box-in2-right-id') || document.body)}
        </>
    );
}
